import { RequestForQuoteGatewayMessage } from '../../../../types/RequestForQuoteGatewayMessage';
import { Text } from '../../../cdl/Text/Text';
import { DataSheet } from '../../../common/DataSheet/DataSheet';
import { formatCompanyName } from '../../../common/helpers/formatCompanyName.helper';
import { formatDate } from '../../../common/helpers/formatDate.helper';
import { translate } from '../../../common/helpers/translate.helper';
import { useRole } from '../../../common/hooks/useRole';
import { InternalNamePopover } from '../../../common/InternalNamePopover';
import { Box } from '../../../common/ui/Box';
import { Port } from '../../../port/Port';

interface RfqDatasheetProps {
    rfq: RequestForQuoteGatewayMessage;
}

export const RfqDatasheet = ({ rfq }: RfqDatasheetProps) => {
    const role = useRole();

    return (
        <DataSheet>
            {role.isSupplier() ? (
                <>
                    <DataSheet.Label>{translate('offer.detail.coreData.company')}</DataSheet.Label>
                    <Box display="flex" alignItems="center" gap={8}>
                        <Text>{formatCompanyName({ company: rfq.supplier })}</Text>
                        <InternalNamePopover company={rfq.supplier} />
                    </Box>
                </>
            ) : null}

            {rfq.port ? (
                <>
                    <DataSheet.Label>{translate('offer.detail.coreData.port')}</DataSheet.Label>
                    <Port port={rfq.port} vesselId={rfq.vesselId} showTooltip />
                </>
            ) : null}

            {rfq.dateDelivery ? (
                <>
                    <DataSheet.Label>{translate('offer.detail.coreData.dateDelivery')}</DataSheet.Label>
                    <Text>{formatDate({ date: rfq.dateDelivery, timeZone: 'UTC' })}</Text>
                </>
            ) : null}

            {rfq.buyerReference ? (
                <>
                    <DataSheet.Label>{translate('offer.detail.coreData.buyerReference')}</DataSheet.Label>
                    <Text>{rfq.buyerReference}</Text>
                </>
            ) : null}

            {rfq.orderNumber ? (
                <>
                    <DataSheet.Label>{translate('order.detail.coreData.orderNumber')}</DataSheet.Label>
                    <Text>{rfq.orderNumber}</Text>
                </>
            ) : null}

            {rfq.dateCreated ? (
                <>
                    <DataSheet.Label>{translate('offer.detail.coreData.dateCreated')}</DataSheet.Label>
                    <Text>{formatDate({ date: rfq.dateCreated, timeZone: 'UTC' })}</Text>
                </>
            ) : null}
        </DataSheet>
    );
};
